<div class="form-group">
  <label *ngIf="label">
    {{ label | translate }}
    <i *ngIf="tooltip" class="fal fa-question-circle" ngbTooltip="{{ tooltip | translate }}"></i>
  </label>
  <div
    ngbDropdown
    #dropDownEle=ngbDropdown
    [autoClose]="'outside'"
    (openChange)="openChange($event)"
    class="{{ dropdownCustomClass }}"
    [container]="ngBootstrapContainer"
  >
    <button class="btn btn-block border text-left input-multi-select" ngbDropdownToggle [disabled]="disabled" (click)="focusInput ? filterListSearch.focusInput() : undefined">
      <div class="d-flex align-items-center">
        <span class="flex-grow-1 text-truncate">
          {{ previewList && previewList.length > 0 ? previewList.join(', ') : (previewEmpty | translate) }}
        </span>
        <i
          class="fa float-right ml-2"
          [ngClass]="{ 'fa-chevron-down': !dropdownIsOpen, 'fa-chevron-up': dropdownIsOpen }"
        ></i>
      </div>
    </button>
    <ul class="input-multi-select-list" ngbDropdownMenu style="z-index: 9999;">
      <li [class.d-none]="optionsList.length === 0 || suppressSearch">
        <lib-filter-list-search #filterListSearch (searchUpdated)="setSearch($event)"></lib-filter-list-search>
      </li>
      <li *ngIf="optionsFilterList.length == 0" class="multi-select-no-results">
        <span translate>NO_RESULTS_FOUND</span>
      </li>
      <li *ngFor="let option of visibleOptions" [ngClass]="{ 'd-none': (!option.id && !showEmptyIds) || option.hide }">
        <button
          class="btn top-filter-item w-100 text-left multi-select-option"
          [class.bg-light]="option.selected"
          (click)="option.selected = !option.selected; setSelectValue(option.id, option.selected)"
          translate
        >
          <div class="d-flex align-items-center justify-content-between w-100 multi-select-option-content">
            <div class="d-flex align-items-center gap-2 multi-select-option-label">
              <i *ngIf="!singleSelection" class="far" [ngClass]="{ 'fa-square': !option.selected, 'fa-check-square': option.selected }"></i>
              <img *ngIf="option._imageValue" [src]="option._imageValue" width="20" height="20" class="flex-shrink-0" />
              <span class="text-truncate">
                <ng-container *ngIf="!singleSelection && !previewField; else newVersion">
                  {{ showId ? option.id : '' }}{{ showId && option.name && option.id ? ' - ' : '' }}{{ option.name }}
                </ng-container>
                <ng-template #newVersion>
                  {{ getPreviewField(option) }}
                </ng-template>
              </span>
            </div>
            <span
              *ngIf="option._badgeValue"
              class="multi-select-option-badge"
              [title]="option._badgeValue"
              ngbTooltip="{{ option._badgeValue }}"
              container="body"
            >
              {{ option._badgeValue }}
            </span>
          </div>
        </button>
      </li>
      <li *ngIf="hasMoreOptions">
        <button class="btn top-filter-item w-100 text-left" (click)="onShowAll()" translate>
          SHOW_ALL_ITEMS
        </button>
      </li>
    </ul>
  </div>
</div>
